import store from "./";
import axios from "axios"

const jsonHeaders = {
    'Content-Type': 'application/json'
}

const isNotFound = (error) => {
    return error && error.response && error.response.status === 404
}

const isNotFoundOrMethodNotAllowed = (error) => {
    return error && error.response && (error.response.status === 404 || error.response.status === 405)
}

const postWithFallback = async (baseUrl, primaryPath, fallbackPath, payload) => {
    try {
        return await axios.post(baseUrl + primaryPath, payload, { headers: jsonHeaders })
    } catch (error) {
        if (!isNotFound(error) || !fallbackPath) {
            throw error
        }

        return axios.post(baseUrl + fallbackPath, payload, { headers: jsonHeaders })
    }
}

const postLegacyAdminLogin = async (baseUrl, credentials) => {
    try {
        return await axios.post(baseUrl + '/api/admin_login_check', credentials, { headers: jsonHeaders })
    } catch (error) {
        if (!isNotFound(error)) {
            throw error
        }

        return axios.post(baseUrl + '/admin_login_check', credentials, { headers: jsonHeaders })
    }
}

const getWithFallback = async (baseUrl, primaryPath, fallbackPath) => {
    try {
        return await axios.get(baseUrl + primaryPath)
    } catch (error) {
        if (!isNotFound(error) || !fallbackPath) {
            throw error
        }

        return axios.get(baseUrl + fallbackPath)
    }
}

const parseProfilePayload = (payload) => {
    if (typeof payload === 'string') {
        return JSON.parse(payload)
    }

    return payload
}

export default {
    state: {
        token: null,
        user: null
    },
    getters: {
        isAuthenticated: (state) => {
            if(state.token && state.user) {
                return true
            }
            return false
        },
        getUser(state) {
            return state.user
        },
        getToken(state) {
            return state.token
        },
        getRolesUser(state) {
            if(state.user !== null)
                //return JSON.parse(state.user.trim()).roles
                return state.user.roles
            else
                return null
        }
    },
    mutations: {
        setToken(state, token) {
            state.token = token
        },
        setUser(state, user) {
            state.user = user
        }
    },
    actions: {
        async login({commit, dispatch}, credentials) {
            store.commit('setLoading', true)

            const apiBase = process.env.VUE_APP_URL_API_BASE
            let response

            try {
                response = await postWithFallback(
                    apiBase,
                    '/api/admin-2fa/login/start',
                    '/admin-2fa/login/start',
                    credentials
                )
            } catch (e) {
                if (isNotFoundOrMethodNotAllowed(e)) {
                    try {
                        response = await postLegacyAdminLogin(apiBase, credentials)
                    } catch (legacyError) {
                        store.commit('setLoading', false)
                        console.error('Login Failed', legacyError.response)
                        return null
                    }
                } else {
                    store.commit('setLoading', false)
                    console.error('Login Failed', e.response)
                    return null
                }
            }

            if (response && response.data) {
                store.commit('setLoading', false)
                if (response.data.requiresTwoFactor) {
                    return {
                        status: '2FA_REQUIRED',
                        pendingToken: response.data.pendingToken,
                        setupRequired: response.data.setupRequired === true,
                        manualSecret: response.data.manualSecret || null,
                        otpAuthUri: response.data.otpAuthUri || null,
                    }
                }

                if (response.data.token) {
                    const result = await dispatch('attempt', response.data.token)
                    return { status: result }
                }

                return null
            }

            store.commit('setLoading', false)
            return null
        },
        async verifyAdmin2fa({dispatch}, payload) {
            store.commit('setLoading', true)

            let response
            try {
                response = await postWithFallback(
                    process.env.VUE_APP_URL_API_BASE,
                    '/api/admin-2fa/login/verify',
                    '/admin-2fa/login/verify',
                    payload
                )
            } catch (e) {
                store.commit('setLoading', false)
                console.error("2FA Verify Failed", e.response)
                return 'Failed'
            }

            if (response && response.data && response.data.token) {
                return dispatch('attempt', response.data.token)
            }

            return 'Failed'
        },
        async attempt({commit, state}, token) {
            if(token) {
                commit('setToken', token)
            }

            if(!state.token) {
                return 'Failed';
            }

            try {
                const apiBase = process.env.VUE_APP_URL_API_BASE
                let response

                try {
                    response = await getWithFallback(apiBase, '/admin/admin-profile', '/api/profile')
                } catch (error) {
                    // If admin endpoint fails server-side, try standard profile endpoint as fallback.
                    if (error && error.response && error.response.status === 500) {
                        response = await axios.get(apiBase + '/api/profile')
                    } else {
                        throw error
                    }
                }

                const profile = parseProfilePayload(response.data)
                commit('setUser', profile)

                store.commit('setLoading', false);
                return 'Success';

            } catch (error) {
                commit('setUser', null);
                commit('setToken', null);
                store.commit('setLoading', false)
                console.error("Profile Failed", error);
                return 'Failed';
            }

            
        },
        logout({commit}) {
            store.commit('setLoading', true);
            localStorage.removeItem('token');
            commit('setUser', null);
            commit('setToken', null);
            store.commit('setLoading', false)
        }
    }
}